"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontsSettingsKeys = exports.NumbersSettingsKeys = exports.BooleansSettingsKeys = exports.MAIN_ITEM_TYPE_VALUES = exports.SHOW_INFO_VALUES = exports.INFO_POSITION_VALUES = exports.LAYOUT_STYLE_VALUES = void 0;
var main_item_type_values_1 = require("./main-item-type-values");
Object.defineProperty(exports, "MAIN_ITEM_TYPE_VALUES", { enumerable: true, get: function () { return main_item_type_values_1.MAIN_ITEM_TYPE_VALUES; } });
var info_position_values_1 = require("./info-position-values");
Object.defineProperty(exports, "INFO_POSITION_VALUES", { enumerable: true, get: function () { return info_position_values_1.INFO_POSITION_VALUES; } });
var show_info_values_1 = require("./show-info-values");
Object.defineProperty(exports, "SHOW_INFO_VALUES", { enumerable: true, get: function () { return show_info_values_1.SHOW_INFO_VALUES; } });
var layout_style_values_1 = require("./layout-style-values");
Object.defineProperty(exports, "LAYOUT_STYLE_VALUES", { enumerable: true, get: function () { return layout_style_values_1.LAYOUT_STYLE_VALUES; } });
var BooleansSettingsKeys;
(function (BooleansSettingsKeys) {
    BooleansSettingsKeys["AutoPlay"] = "autoPlay";
    BooleansSettingsKeys["BiAppSettingsWhereOpened"] = "biAppSettingsWhereOpened";
})(BooleansSettingsKeys = exports.BooleansSettingsKeys || (exports.BooleansSettingsKeys = {}));
var NumbersSettingsKeys;
(function (NumbersSettingsKeys) {
    NumbersSettingsKeys["ThumbnailButtonsBehavior"] = "thumbnailButtonsBehavior";
    NumbersSettingsKeys["MobileChannelLayout"] = "mobileChannelLayout";
    NumbersSettingsKeys["ChannelLayout"] = "channelLayout";
    NumbersSettingsKeys["PlayType"] = "playType";
    NumbersSettingsKeys["VideosInRow"] = "videosInRow";
    NumbersSettingsKeys["NumberOfRows"] = "numberOfRows";
    NumbersSettingsKeys["MainItemType"] = "mainItemType";
})(NumbersSettingsKeys = exports.NumbersSettingsKeys || (exports.NumbersSettingsKeys = {}));
var FontsSettingsKeys;
(function (FontsSettingsKeys) {
    FontsSettingsKeys["ChannelId"] = "channelId";
    FontsSettingsKeys["VideoId"] = "videoId";
})(FontsSettingsKeys = exports.FontsSettingsKeys || (exports.FontsSettingsKeys = {}));
//# sourceMappingURL=index.js.map